var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup_list"},[_c('div',{staticClass:"wrap"},[_c('youtube',{staticClass:"youtube",attrs:{"video-id":_vm.videoId,"player-width":_vm.youtubeWidth,"player-height":_vm.youtubeHeight}})],1),_vm._v(" "),_c('a',{staticClass:"overlay",on:{"click":function($event){return _vm.closePopup('')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-653c481a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beautiful-chat/YoutubePop.vue
// module id = null
// module chunks = 